import { useTranslation } from '@pos/i18n';
import { DateRangeFilter } from '../fields/DateField';
import { useReferenceOptions } from '../fields/references';
import { ChoiceDropdown } from '../filters/ResourceFilters';
import type { OrdersMode } from './model';

export interface FilterOption {
  id: string;
  label: string;
}

/** One option or All, as a dropdown titled and prompting with its label (the filter panel's style). */
export function FilterDropdown({
  id,
  label,
  options,
  value,
  onChange,
}: {
  id: string;
  label: string;
  options: FilterOption[];
  value: string;
  onChange(value: string): void;
}) {
  return <ChoiceDropdown id={id} label={label} choices={options} value={value} onChange={onChange} />;
}

export interface DateStoreValue {
  from: string;
  to: string;
  storeId: string;
}

/** Date range, and at HO the store. */
export function DateStoreFilters({
  idPrefix,
  mode,
  value,
  onChange,
}: {
  idPrefix: string;
  mode: OrdersMode;
  value: DateStoreValue;
  onChange(v: DateStoreValue): void;
}) {
  const { t } = useTranslation();
  const stores = useReferenceOptions(mode === 'ho' ? 'org.store' : undefined);
  return (
    <>
      <DateRangeFilter
        id={idPrefix}
        legendText={t('transactions.filters.date')}
        fromLabel={t('transactions.filters.from')}
        toLabel={t('transactions.filters.to')}
        from={value.from}
        to={value.to}
        onChange={(range) => onChange({ ...value, ...range })}
      />
      {mode === 'ho' && (
        <FilterDropdown
          id={`${idPrefix}-store`}
          label={t('transactions.filters.store')}
          options={(stores.data ?? []).map((s) => ({ id: s.value, label: s.label }))}
          value={value.storeId}
          onChange={(storeId) => onChange({ ...value, storeId })}
        />
      )}
    </>
  );
}

/** The store's name at HO. */
export function StoreName({ id }: { id: string }) {
  const stores = useReferenceOptions('org.store');
  return <>{stores.data?.find((s) => s.value === id)?.label ?? ''}</>;
}
